import React from "react";
import "./index";
import {
  faArrowDown,
  faArrowRight,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RowsTarefa = ({ tarefa, index }) => {
  let el = (
    <FontAwesomeIcon
      title="Em Andamento"
      className="icon-andamento"
      icon={faArrowRight}
    />
  );

  if (tarefa.previsto > tarefa.realizado) {
    el = (
      <FontAwesomeIcon
        title="Atraso"
        className="icon-atraso"
        icon={faArrowDown}
      />
    );
  } else if (tarefa.previsto < tarefa.realizado) {
    el = (
      <FontAwesomeIcon
        title="Antecipado"
        className="icon-antecipado"
        icon={faArrowUp}
      />
    );
  }

  const isSumary = tarefa.is_sumary ? "font-bold" : "";

  return (
    <>
      <tr key={index} className={isSumary}>
        <td className="text-center">{index + 1}</td>
        <td className="text-center">{tarefa.local}</td>
        <td className="text-center">{tarefa.servico}</td>
        <td className="text-center">{tarefa.empreiteiro}</td>
        <td className="text-center">{tarefa.justificativa}</td>
        <td className="text-center">
          {new Date(tarefa.inicio_gerencial).toLocaleDateString()}
        </td>
        <td className="text-center">{tarefa?.duracaoReal}</td>
        <td className="text-center">
          {new Date(tarefa.termino_gerencial).toLocaleDateString()}
        </td>
        <td className="text-center">{tarefa.previsto}%</td>
        <td className="text-center">{tarefa.realizado}%</td>
        <td className="text-center">{el}</td>
      </tr>
    </>
  );
};

export default RowsTarefa;
